/**
 * Constants for chat functionality
 */

// Polling intervals and timeouts
export const POLLING_INTERVAL_MS = 2000; // 2 seconds
export const POLLING_TIMEOUT_MS = 300000; // 5 minutes

// Account name mappings for C1 action handling
export const TAXABLE_ACCOUNT_MAP: Record<string, string> = {
  taxable_brokerage: "Taxable Brokerage",
  ss_benefits: "SS Benefits",
  home: "Home",
} as const;

export const IRA_ACCOUNT_MAP: Record<string, string> = {
  jane_ira: "Jane's IRA",
  john_401k: "John's 401k",
} as const;

// Regex patterns for content processing
export const THESYS_COMPONENT_REGEX = /<content\s+thesys="true">\s*({[\s\S]*?})\s*<\/content>/g;
export const TOOL_URL_REGEX = /tool:\/\/functions\.(.+)/;
export const RETRIEVED_DATA_REGEX = /Retrieved\s+\w+\s+data:\s*\{[\s\S]*?\}(\s*$|\s*\n)/g;
export const RETRIEVED_DATA_LINE_REGEX = /Retrieved\s+\w+\s+data:.*$/gm;
export const JSON_CODE_BLOCK_REGEX = /```json\s*\{[\s\S]*?\}\s*```/g;
export const RAW_DATA_MARKER_REGEX = /^(Retrieved|Tool|Data|Result)$/i;

// Message ID prefixes
export const MESSAGE_ID_PREFIXES = {
  USER: 'user',
  ASSISTANT: 'assistant',
  ERROR: 'error',
  TOOL: 'tool',
} as const;

// Tool URL prefix
export const TOOL_URL_PREFIX = 'tool://';

